module.exports = __webpack_public_path__ + "static/clean-coder-7b06b9bed9015bf1e2de5b1c76f4d290.jpeg";